module.exports = __webpack_public_path__ + "static/media/TropicStateofMind.e532e997.jpg";